import React from "react";
import { Text } from "@pushpress/shared-components";
import { CreditCount } from "./AppointmentCredits.types";
import styles from "./CreditsSummary.module.scss";

interface CreditsSummaryProps {
  data: CreditCount[];
}

function CreditsSummary(props: CreditsSummaryProps) {
  const { data } = props;

  return (
    <div className={styles.root} aria-label="Credits summary">
      <div className={styles.header}>
        <Text component="h2" variant="heading-5" color="wolf-800">
          Credits summary
        </Text>
        <Text component="span" variant="body-md" color="wolf-600">
          Active credits
        </Text>
      </div>
      <div className={styles.body}>
        <dl className={styles.list}>
          {data.map((item) => (
            <div key={item.name} className={styles.item}>
              <dt className={styles.term}>
                <Text component="span" variant="body-lg" color="wolf-800">
                  {item.name}
                </Text>
              </dt>
              <dd className={styles.description}>
                <Text component="span" variant="body-lg" color="wolf-800">
                  {item.count}
                </Text>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}

export default CreditsSummary;
